import React from 'react';
import Container from 'react-bootstrap/esm/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/esm/Button';
import { useNavigate } from 'react-router-dom';

function EditProctorSuccess() {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate("/AdministratorDashboard", {state: {toProctor: true}});
    };

    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100">
        <Container className="mt-5 text-center centered-form rounded">
            <Row>
                <Col>
                    <h2>Proctor Availability Updated Successfully!</h2>
                    <Button 
                        variant="primary" 
                        className="mt-5"
                        onClick={handleGoBack}
                    >
                        Back To Dashboard
                    </Button>
                </Col>
            </Row>
        </Container>
        </div>
    );
}

export default EditProctorSuccess; 